import PropTypes from "prop-types";

export default function LabelDetail({ children, className = "", other }) {
  return (
    <div
      className={` ${className}`}
      {...other}
      style={{
        fontSize: "12px",
        fontWeight: 400,
        color: " var(--color-on-base-content-subtle)",
      }}
    >
      {children}
    </div>
  );
}

LabelDetail.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  other: PropTypes.any,
};
